export const GetAllServiceChatBookingQuery = `
query GetAllServiceChatBooking {
    getAllServiceChatBooking {
        firstName
        lastName
        email
        phoneNumber
        status
        createdAt
        id
    }
}
`;

export const GetServiceChatBookingById = `
query GetServiceChatBookingById($id: ID!) {
    getServiceChatBookingById(id: $id) {
        id
        firstName
        lastName
        email
        phoneNumber
        status
        createdAt
        lastUpdatedAt
        lastUpdatedBy
        message
    }
}
`;

export const UpdateServiceChatBookinQuery = `
mutation UpdateServiceChatBooking($input: UpdateServiceChatStatusInput!) {
    updateServiceChatBooking(input: $input) {
        id
        firstName
        lastName
        email
        phoneNumber
        status
        createdAt
        lastUpdatedAt
        lastUpdatedBy
        message
    }
}
`;
